(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-title"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ambient-title')) {
    customElements.define('ambient-title', class extends HTMLElement {
      connectedCallback() {
        this.observer?.disconnect();
        this.observer = new IntersectionObserver(entries => {
          this.dataset.visible = String(entries[0].isIntersecting);
        });
        this.observer.observe(this);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  class FloatingCartButton extends HTMLElement {
    connectedCallback() {
      this.link = this.querySelector('[data-floating-cart-button-link]');
      this.header = document.querySelector('.section-header');
      this.headerCart = document.getElementById('cart-icon-bubble');
      this.cartDrawer = document.querySelector('cart-drawer');
      this.onScrollHandler = this.scheduleVisibilityUpdate.bind(this);

      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      window.addEventListener('resize', this.onScrollHandler);

      if (this.cartDrawer) {
        this.setDrawerAccessibility();
      }

      if (this.headerCart) {
        this.observer = new MutationObserver(this.syncCartContents.bind(this));
        this.observer.observe(this.headerCart, { childList: true, subtree: true });
      }

      this.bodyClassObserver = new MutationObserver(this.scheduleVisibilityUpdate.bind(this));
      this.bodyClassObserver.observe(document.body, { attributeFilter: ['class'] });

      this.syncCartContents();
      this.scheduleVisibilityUpdate();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onScrollHandler);
      this.observer?.disconnect();
      this.bodyClassObserver?.disconnect();
    }

    setDrawerAccessibility() {
      this.link.setAttribute('role', 'button');
      this.link.setAttribute('aria-haspopup', 'dialog');

      this.link.addEventListener('click', (event) => {
        event.preventDefault();
        this.cartDrawer.open(this.link);
      });

      this.link.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.cartDrawer.open(this.link);
        }
      });
    }

    syncCartContents() {
      if (!this.link || !this.headerCart) return;
      this.link.innerHTML = this.headerCart.innerHTML;
    }

    scheduleVisibilityUpdate() {
      if (this.visibilityFrame) return;

      this.visibilityFrame = requestAnimationFrame(() => {
        this.visibilityFrame = null;
        this.updateVisibility();
      });
    }

    updateVisibility() {
      if (!this.link || !this.header) return;

      const isHeaderHidden = this.header.classList.contains('shopify-section-header-hidden');
      const isMenuOpen = this.header.classList.contains('menu-open');
      const isOverlayOpen = document.body.classList.contains('overflow-hidden');
      const isPastHeader = window.scrollY > this.header.offsetHeight;
      const headerRect = this.header.getBoundingClientRect();
      const isHeaderVisible = headerRect.bottom > 0 && headerRect.top < window.innerHeight && !isHeaderHidden;
      const shouldShow = isPastHeader && !isHeaderVisible && !isMenuOpen && !isOverlayOpen;

      this.classList.toggle('is-visible', shouldShow);
      this.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      this.link.tabIndex = shouldShow ? 0 : -1;
    }
  }

  if (!customElements.get('floating-cart-button')) {
    customElements.define('floating-cart-button', FloatingCartButton);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multirow"] && !Shopify.designMode) return;
  try {
    
  class ProductAvailability extends HTMLElement {
    connectedCallback() {
      const productUrl = this.dataset.productAvailabilityUrl;
      const productHandle = this.getProductHandle(productUrl);

      if (!productHandle) return;

      const routesRoot = window.Shopify?.routes?.root || '/';
      fetch(`${routesRoot}products/${productHandle}.js`)
        .then((response) => {
          if (!response.ok) return null;
          return response.json();
        })
        .then((product) => {
          if (!product || !Array.isArray(product.variants)) return;

          const availability = this.getAvailability(product, productUrl);

          if (availability.labels.length === 0) return;

          this.replaceChildren();
          availability.labels.forEach((label, index) => {
            if (index > 0) this.appendChild(document.createElement('br'));
            this.appendChild(document.createTextNode(label));
          });
          this.hidden = false;

          const button = this.parentElement.querySelector('.button');
          if (button) {
            button.textContent = availability.available
              ? this.dataset.productButtonLabel
              : this.dataset.productViewMore;
          }
        })
        .catch(() => {});
    }

    getProductHandle(productUrl) {
      if (!productUrl) return '';

      try {
        const url = new URL(productUrl, window.location.origin);
        const match = url.pathname.match(/\/products\/([^/?#]+)/);
        return match ? match[1] : '';
      } catch (error) {
        const match = productUrl.match(/\/products\/([^/?#]+)/);
        return match ? match[1] : '';
      }
    }

    getVariantId(productUrl) {
      try {
        return new URL(productUrl, window.location.origin).searchParams.get('variant');
      } catch (error) {
        const match = productUrl.match(/[?&]variant=([^&#]+)/);
        return match ? match[1] : '';
      }
    }

    getAvailability(product, productUrl) {
      if (this.dataset.productAvailabilityMode === 'service') {
        return {
          available: product.available,
          labels: [product.available
            ? this.dataset.productServiceAvailable
            : this.dataset.productServiceUnavailable],
        };
      }

      if (this.dataset.productAvailabilityMode === 'course') {
        return {
          available: product.available,
          labels: product.variants.map((variant) => this.getCourseVariantLabel(variant, product)).filter(Boolean),
        };
      }

      const variantId = this.getVariantId(productUrl);
      const variant =
        product.variants.find((item) => variantId && String(item.id) === String(variantId)) ||
        product.variants.find((item) => item.available) ||
        product.variants[0];
      const available = variant ? variant.available : product.available;
      const label =
        this.dataset.productAvailabilityMode === 'digital' && available
          ? this.dataset.productAvailableToDownload
          : available
            ? this.dataset.productInStock
            : this.dataset.productOutOfStock;

      return { available, labels: label ? [label] : [] };
    }

    getCourseVariantLabel(variant, product) {
      let courseDate = variant.public_title || variant.title || '';

      if (!courseDate || courseDate === 'Default Title') {
        const titleMatch = product.title.match(/\(([^)]+)\)/);
        courseDate = titleMatch ? titleMatch[1] : '';
      }

      const status = variant.available
        ? this.dataset.productPlacesAvailable
        : this.dataset.productFullyBooked;
      return courseDate ? `${courseDate}: ${status}` : status;
    }
  }

  if (!customElements.get('product-availability')) {
    customElements.define('product-availability', ProductAvailability);
  }

  } catch(e) { console.error(e); }
})();
})();
